module.exports = __webpack_public_path__ + "static/gm-21-81664e6c82e20d304704311b0bf57723.jpg";